export enum MessageCenterPaneStyles {
     Visible = 'visible'
}
